import { useState } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Button, Collapse, Table, FormGroup, Label, Input, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import uuid from 'react-uuid';
import moment from "moment";
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const FarmList = ({ refreshToken,farmsList, tempFarmsList, totalFarmDetails, itemModel, handleWizardFarmChanged, userId, isInvited }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true); 
    const [name, setName] = useState('');
    const [farmItems, setFarmItems] = useState(farmsList);
    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [sortConfigMaster, setSortConfigMaster] = useState(null);
    const [defaultFarmId, setDefaultFarmId] = useLocalStorage('defaultFarmId', '');
    const [defaultFarmName, setDefaultFarmName] = useLocalStorage('defaultFarmName', '');
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useLocalStorage('defaultFarmUniqueId', '');
    const toggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const handleSetFarm = async (e, id) => {
        e.preventDefault();
        const farmId = parseInt(id);
        try {
            const response = await apiGet(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            setDefaultFarmId(id);
            setDefaultFarmName(response.data.name);
            setDefaultFarmUniqueId(response.data.uniqueIdentifier);
            //localStorage.setItem("defaultFarmId", JSON.stringify(id));
            //localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            //localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            localStorage.setItem("isAddArchiveItem", response.data.isAddArchiveItem);
            localStorage.setItem("isAddEditItem", response.data.isAddEditItem);
            localStorage.setItem("isCreateNewAction", response.data.isCreateNewAction);
            localStorage.setItem("isSubmitEvidenceCloseAction", response.data.isSubmitEvidenceCloseAction);
            localStorage.setItem("isAddDeleteDocument", response.data.isAddDeleteDocument);
            localStorage.setItem("saveRightsForNonItemFieldsAndTables", response.data.saveRightsForNonItemFieldsAndTables);
            localStorage.setItem("farmRoleName", response.data.farmRole);
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleChangeName = async (event) => {
        setName(event.target.value);
        if (event.target.value == '') {
            setFarmItems(tempFarmsList);
        }
        else {
            var list = [];
            list = tempFarmsList.filter(x => (x.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                (x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) : 0) ||
                (x.parentOrganisationName != null ? x.parentOrganisationName.toLowerCase().includes(event.target.value.toLowerCase()) : 0) ||
                (x.farmRegion != null ? x.farmRegion.toLowerCase().includes(event.target.value.toLowerCase()) : 0) ||
                (x.farmRegion != null ? x.status.toLowerCase().includes(event.target.value.toLowerCase()) : 0)  ||
                (x.fepLastUpdatedDate != null ? x.fepLastUpdatedDate.toLowerCase().includes(event.target.value.toLowerCase()) : 0) ||
                (x.openActions != null ? x.openActions.toLowerCase().includes(event.target.value.toLowerCase()) : 0)
            ));
            setFarmItems(list);
        }
        setCurrentPage(1);
    }

    const exportFarmListToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportExcel = async (e) => {

        var selectedFarmlist = farmItems.map(r => r.uniqueIdentifier).join(",");
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportFarmListExcel/', {
                params: { userId: userId, farmList: selectedFarmlist },
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            var currentDate = new Date();
            link.download = "FWFP Vineyard List " + moment(currentDate).format('DD-MM-YYYY') + ".xlsx";

            document.body.appendChild(link)
            link.click()
        }

    }

    const exportFarmListToPdf = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportPdf = async (e) => {
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportFarmListPDF/', {
                params: { userId: userId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FarmList.pdf";
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const useSortableData = (items, config = null) => {
        //const [sortConfig, setSortConfig] = React.useState(config);
        if (sortConfigMaster == null) {
            setSortConfigMaster({ key: 'name', direction:'ascending' });
        }
        const sortedItems = React.useMemo(() => {
            let sortableItems = [...items];
            if (sortConfigMaster !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfigMaster.key] < b[sortConfigMaster.key]) {
                        return sortConfigMaster.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfigMaster.key] > b[sortConfigMaster.key]) {
                        return sortConfigMaster.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfigMaster]);

        const requestSort = (key) => {
            let direction = 'ascending';
            if (
                sortConfigMaster &&
                sortConfigMaster.key === key &&
                sortConfigMaster.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            //setSortConfig({ key, direction });
            setSortConfigMaster({ key, direction })
        };

        return { items: sortedItems, requestSort, sortConfigMaster };
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const ProductTable = (props) => {
        const { items, requestSort, sortConfig } = useSortableData(props.products);
        const getClassNamesFor = (name) => {
            if (!sortConfigMaster) {
                return;
            }
            return sortConfigMaster.key === name ? sortConfigMaster.direction : undefined;
        };
        return (
            <>
                <Table striped bordered hover style={{  width: '100%' }}>
                <thead className="text-left">
                    <tr>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('uniqueIdentifier')}
                                className={getClassNamesFor('uniqueIdentifier')}
                            >
                                Vineyard ID
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('name')}
                                className={getClassNamesFor('name')}
                            >
                                Vineyard Name
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('parentOrganisationName')}
                                className={getClassNamesFor('parentOrganisationName')}
                            >
                                Organisation Name
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('farmRegion')}
                                className={getClassNamesFor('farmRegion')}
                            >
                                Organisation Region
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('fepLastUpdatedDate')}
                                className={getClassNamesFor('fepLastUpdatedDate')}
                                style={{ textAlign: "center" }}
                            >
                                Last Updated
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('status')}
                                className={getClassNamesFor('status')}
                            >
                                Status
                            </button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                            <button
                                type="button"
                                    onClick={() => requestSort('openActionsCount')}
                                    className={getClassNamesFor('openActionsCount')}
                            >
                                # Open Actions
                            </button>
                            
                        </th>
                        <th>
                                View
                        </th>
                        {
                            isInvited && 
                            <th>
                                    Access expiry
                            </th>
                        }
                    </tr>
                </thead>
                <tbody className="text-left">
                        {items != undefined && items != null &&
                            items.slice(indexOfFirstItem, indexOfLastItem) != undefined && items.slice(indexOfFirstItem, indexOfLastItem) != null &&
                            items.slice(indexOfFirstItem, indexOfLastItem).map(item => (
                        <tr key={uuid()}>
                            <td>{item.uniqueIdentifier}</td>
                            <td>{item.name} </td>
                            <td>{item.parentOrganisationName} </td>
                            <td>{item.farmRegion} </td>
                            <td style={{ textAlign: "center" }}>{item.fepLastUpdatedDate != null ? moment(item.fepLastUpdatedDate).format("DD/MM/YYYY") : ""}</td>
                            <td>{item.status}</td>
                            <td style={{ textAlign: "center" }}>{item.openActions}</td>
                            <td>
                                <Button id={item.id} color="success" onClick={(e) => handleSetFarm(e, item.id)}> <FaChevronRight /></Button>
                            </td>
                            {
                                isInvited &&
                                <td>{item.accessExpiry}</td>
                            }
                        </tr>
                    ))}
                </tbody>
                </Table>
                <Pagination>
                    <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
                    </PaginationItem>
                    {[...Array(Math.ceil(items.length / itemsPerPage))].map((item, index) => (
                        <PaginationItem key={index} active={currentPage === index + 1}>
                            <PaginationLink onClick={() => handlePageChange(index + 1)}>{index + 1}</PaginationLink>
                        </PaginationItem>
                    ))}

                    <PaginationItem disabled={currentPage === Math.ceil(items.length / itemsPerPage)}>
                        <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
                    </PaginationItem>
                </Pagination>
            </>
        );
    };
    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card className="my-4 flex-grow-1 d-flex flex-column" style={{ maxHeight: "100vw" }}>
                        <CardHeader className="item-header item_click" onClick={toggle}>
                            <Row>
                                <Col sm="11">
                                    <h6>Vineyards List
                                        <Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportFarmListToExcel(e)} value="Export" placeholder="">
                                            <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                        </Button>
                                    </h6>
                                </Col>
                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Collapse isOpen={isOpen}>
                                <div> 
                                    
                                    <Row style={{ marginTop:"10px" }}>
                                        <Col md="9">
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                   
                                    <ProductTable
                                        products={farmItems}
                                    />
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
export default FarmList;